export default {
    init() {
        //Only load on metrics page and if there is data
        if (typeof metricsData !== 'undefined'){
            console.log(metricsData.status_msg);
        
            const monthOptions = document.getElementById("report_month");
            const regionOptions = document.getElementById("region");
            const countryOptions = document.getElementById("country");

            function loadLanguageInFields(months, regions) {
                //load months
                monthOptions.innerHTML = '';
                for (let [key, value] of Object.entries(months)) {
                    var elM = document.createElement("option");
                    elM.textContent = value;
                    elM.value = key;
                    monthOptions.appendChild(elM);
                }

                //load regions
                regionOptions.innerHTML = '';
                for (let [key, value] of Object.entries(regions)) {
                    var elR = document.createElement("option");
                    elR.textContent = value;
                    elR.value = key;
                    regionOptions.appendChild(elR);
                }
            }

            function loadLanguageInCountryFields(countries) {
                //load countries
                countryOptions.innerHTML = '';
                for (let [key, value] of Object.entries(countries)) {
                    var elC = document.createElement("option");
                    elC.textContent = value;
                    elC.value = key;
                    countryOptions.appendChild(elC);
                }
            }

            function resetCountries(language) {
                $('#country').empty();
                $('#country').prepend("<option class='none-option' val='none'>" + metricsData[language].country_default_msg + "'</option>");
            }

            function changeLanguage(language) {
                resetCountries(language);
                loadLanguageInFields(metricsData[language].months, metricsData[language].regions);
                switch (language) {
                    case 'english':
                        $('.metrics-notice-msg').text('This page is for Precept Employees. If you are not an employee and instead are interested in financial disclosure statements or other metrics, please visit ');
                        $('<a href="https://www.precept.org/give/#Financial-Statements" style="text-decoration:underline">Financial Statements</a>').appendTo('.metrics-notice-msg');
                        $('h1').text('Country Report');
                        $('.metrics-notice-msg').show();
                        $('h3.submitter-info').text('Submitter Info');
                        $('.field.language .main-label').text('Language *');
                        $('.field.report-submitter .main-label').text('Report Submitter *');
                        $('.field.submitter-code .main-label').text('Submitter Code *');
                        $('h3.report-info').text('Report Info');
                        $('.field.report-month .main-label').text('Report Month *');
                        $('.field.report-year .main-label').text('Report Year *');
                        $('.field.region .main-label').text('Region *');
                        $('.field.country .main-label').text('Country *');
                        $('h3.materials').text('Materials');
                        $('.field.materials-given-away .main-label').text('Materials Given Away');
                        $('.field.materials-sold .main-label').text('Materials Sold');
                        $('h3.activities').text('Activities');
                        $('.field.number-of-active-bsls .main-label').text('Number of Active BSLs');
                        $('.field.number-of-classes .main-label').text('Number of Classes');
                        $('.field.number-of-leader-training-events .main-label').text('Number of  Leader Training Events');
                        $('.field.number-of-new-bsls .main-label').text('Number of New BSLs');
                        $('.field.number-of-students .main-label').text('Number of Students');
                        $('#submit_button').val('Submit');
                        $('#report_year .none-option').text('--None--');
                        $('#country .none-option').text(metricsData.english.country_default_msg);
                        break;
                    case 'chinese':
                        //$('.metrics-notice-msg').text('此页面适用于 Precept 员工。 如果您不是员工而是对财务披露报表或其他指标感兴趣，请访问');
                        //$('<a href="https://www.precept.org/give/#Financial-Statements" style="text-decoration:underline">财务报表</a>.').appendTo('.metrics-notice-msg');
                        $('h1').text('國家報告');
                        $('.metrics-notice-msg').hide();
                        $('h3.submitter-info').text('提交者資料');
                        $('.field.language .main-label').text('語言 *');
                        $('.field.report-submitter .main-label').text('報告提交者 *');
                        $('.field.submitter-code .main-label').text('提交者代號 *');
                        $('h3.report-info').text('報告資料');
                        $('.field.report-month .main-label').text('報告月份 *');
                        $('.field.report-year .main-label').text('報告年份 *');
                        $('.field.region .main-label').text('地區 *');
                        $('.field.country .main-label').text('國家 *');
                        $('h3.materials').text('教材');
                        $('.field.materials-given-away .main-label').text('教材贈送');
                        $('.field.materials-sold .main-label').text('教材售出');
                        $('h3.activities').text('活動');
                        $('.field.number-of-active-bsls .main-label').text('帶領者');
                        $('.field.number-of-classes .main-label').text('查經班');
                        $('.field.number-of-leader-training-events .main-label').text('帶領者培訓');
                        $('.field.number-of-new-bsls .main-label').text('儲備帶領者');
                        $('.field.number-of-students .main-label').text('學員');
                        $('#submit_button').val('提交');
                        $('#report_year .none-option').text('--没有任何--');
                        $('#country .none-option').text(metricsData.chinese.country_default_msg);
                        break;
                    case 'romanian':
                        //$('.metrics-notice-msg').text('Această pagină este destinată angajaților Precept. Dacă nu sunteți un angajat și, în schimb, sunteți interesat de declarațiile de divulgare financiară sau alte valori, vă rugăm să vizitați ');
                        //$('<a href="https://www.precept.org/give/#Financial-Statements" style="text-decoration:underline">Declarații financiare</a>').appendTo('.metrics-notice-msg');
                        $('h1').text('Numele tarii');
                        $('.metrics-notice-msg').hide();
                        $('h3.submitter-info').text('informatia celui ce completeaza');
                        $('.field.language .main-label').text('Limba *');
                        $('.field.report-submitter .main-label').text('Numele persoanei *');
                        $('.field.submitter-code .main-label').text('Codul persoanei *');
                        $('h3.report-info').text('Informatia despre raport');
                        $('.field.report-month .main-label').text('Luna raportului *');
                        $('.field.report-year .main-label').text('Anul raportului *');
                        $('.field.region .main-label').text('Teritoriu regional *');
                        $('.field.country .main-label').text('Tara *');
                        $('h3.materials').text('Literatura');
                        $('.field.materials-given-away .main-label').text('Literatura fara plata');
                        $('.field.materials-sold .main-label').text('Literatura cu plata');
                        $('h3.activities').text('Activitati');
                        $('.field.number-of-active-bsls .main-label').text('Numar de lideri activi');
                        $('.field.number-of-classes .main-label').text('Numarul claselor');
                        $('.field.number-of-leader-training-events .main-label').text('Numar Evenimente/Pregatiri seminare,et');
                        $('.field.number-of-new-bsls .main-label').text('Numarul de noi lideri');
                        $('.field.number-of-students .main-label').text('Numarul studentilor');
                        $('#submit_button').val('Prezinta');
                        $('#report_year .none-option').text('--nici una--');
                        $('#country .none-option').text(metricsData.romanian.country_default_msg);
                        break;
                    case 'russian':
                        //$('.metrics-notice-msg').text('Эта страница предназначена для сотрудников Precept. Если вы не являетесь сотрудником и вместо этого заинтересованы в раскрытии финансовой отчетности или других показателях, посетите ');
                        //$('<a href="https://www.precept.org/give/#Financial-Statements" style="text-decoration:underline">Финансовые отчеты</a>').appendTo('.metrics-notice-msg');
                        $('h1').text('Отчет по стране');
                        $('.metrics-notice-msg').hide();
                        $('h3.submitter-info').text('Информация подателя');
                        $('.field.language .main-label').text('язык');
                        $('.field.report-submitter .main-label').text('Заполнил отчет *');
                        $('.field.submitter-code .main-label').text('Код подателя *');
                        $('h3.report-info').text('Информация отчета');
                        $('.field.report-month .main-label').text('Отчет за месяц *');
                        $('.field.report-year .main-label').text('Отчет за год *');
                        $('.field.region .main-label').text('Регион *');
                        $('.field.country .main-label').text('Страна *');
                        $('h3.materials').text('Литература');
                        $('.field.materials-given-away .main-label').text('Литература подаренная');
                        $('.field.materials-sold .main-label').text('Литература проданная');
                        $('h3.activities').text('Деятельность');
                        $('.field.number-of-active-bsls .main-label').text('Количество активных лидеров');
                        $('.field.number-of-classes .main-label').text('Количество групп');
                        $('.field.number-of-leader-training-events .main-label').text('Количество мероприятий по подготовке лидеров');
                        $('.field.number-of-new-bsls .main-label').text('Количество новых лидеров');
                        $('.field.number-of-students .main-label').text('Количество студентов');
                        $('#submit_button').val('Отправить');
                        $('#report_year .none-option').text('--None--');
                        $('#country .none-option').text(metricsData.russian.country_default_msg);
                        break;
                    case 'spanish':
                        //$('.metrics-notice-msg').text('Esta página es para empleados de Precept. Si no es un empleado y, en cambio, está interesado en declaraciones de divulgación financiera u otras métricas, visite ');
                        //$('<a href="https://www.precept.org/give/#Financial-Statements" style="text-decoration:underline">Estados financieros</a>').appendTo('.metrics-notice-msg');
                        $('h1').text('Reporte de País');
                        $('.metrics-notice-msg').hide();
                        $('h3.submitter-info').text('Información del Remitente');
                        $('.field.language .main-label').text('Idioma *');
                        $('.field.report-submitter .main-label').text('Remitente del Reporte *');
                        $('.field.submitter-code .main-label').text('Código del Remitente *');
                        $('h3.report-info').text('Información del Reporte');
                        $('.field.report-month .main-label').text('Mes del Reporte *');
                        $('.field.report-year .main-label').text('Año del Reporte *');
                        $('.field.region .main-label').text('Región *');
                        $('.field.country .main-label').text('País *');
                        $('h3.materials').text('Materiales');
                        $('.field.materials-given-away .main-label').text('Materiales Regalados');
                        $('.field.materials-sold .main-label').text('Materiales Vendidos');
                        $('h3.activities').text('Actividades');
                        $('.field.number-of-active-bsls .main-label').text('Número de Líderes activos');
                        $('.field.number-of-classes .main-label').text('Número de Clases');
                        $('.field.number-of-leader-training-events .main-label').text('Número Eventos Entrenamiento de Líderes');
                        $('.field.number-of-new-bsls .main-label').text('Número de Líderes Nuevos');
                        $('.field.number-of-students .main-label').text('Número de Estudiantes');
                        $('#submit_button').val('Ingresar');
                        $('#report_year .none-option').text('--Ninguno--');
                        $('#country .none-option').text(metricsData.spanish.country_default_msg);
                        break;
                    default:
                        history.pushState(null, null, "");
                }; //end switch 
            }

            function populateCountries(languageSelected, regionSelected) {
                loadLanguageInCountryFields(metricsData[languageSelected][regionSelected]);
            }
            function amendUrl(languageSelected) {
                history.pushState(null, null, "?lang=" + metricsData[languageSelected].lang);
            }

            //For metrics pages, see if language is in the url and load that language
            if (window.location.href.indexOf("metrics") > -1) {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                let lang = urlParams.get('lang');
                if (lang === null){lang = "en_US";} 
                const language = metricsData.lang[lang];
                $('#language option[value='+language+']').prop('selected', true);
                changeLanguage(language);
            }

            //change the language of the page based on the language selected and amend the URL
            $('#language').on('change', function () {
                var languageSelected = this.value;
                amendUrl(languageSelected);
                changeLanguage(languageSelected);
            });//end code

            //populate the countries in the right language based on the region selected
            $('#region').on('change', function () {
                var languageSelected = $('#language').val();
                var regionSelected = this.value;
                populateCountries(languageSelected, regionSelected);
            });

            $('#submit_another').on('click', function () {
                var languageSelected = $("#language").val();
                amendUrl(languageSelected);
                location.reload();
            });

            //Submit New metrics
            var metricsSubmitCount = 0;
            $('form#metrics-form').on('submit', function (event) {
                //grechaptcha
                event.preventDefault();
                var that = this;//set that variable so it will be available in next function
                metricsSubmitCount++;
                if (metricsSubmitCount <= 1) {//Prevent double-click
                    if ($('#recaptchaResponse').length) {
                        grecaptcha.ready(function () {
                            grecaptcha.execute('6Lerg-kUAAAAAOKHCBzpYMKugpr8WKG6fNPdhy6K', { action: 'register' }).then(function (token) {
                                
                                var recaptchaResponse = document.getElementById('recaptchaResponse');
                                recaptchaResponse.value = token;

                                $(that).off("submit"); // to guarantee the function won't be invoked
                                that.submit();
                            });
                        });
                    }
                }
                
                //This is to ensure that the status message boxes will display on submission. If there is a param in the URL, none of the messages will show.
                if ($('#status') == "submitted"){
                    window.history.replaceState({}, document.title, "/" + "metrics/");
                } 
                
            });

        }

    }
}
